
define('text!modules/reporting/campaigns/performance/templates/layout.html',[],function () { return '<div class="report-chart chart-series"></div>\n<div class="report-controls {{#chartHidden}}collapsed{{/chartHidden}}"></div>\n<div class="report-grid"></div>\n';});

